var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___ZG1qZ3",
  "pG": "ChannelOverviewTab.module__regionEmoji___ZG1qZ3",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___ZG1qZ3",
  "c5": "ChannelOverviewTab.module__topicInput___ZG1qZ3",
  "Z8": "ChannelOverviewTab.module__emojiButton___ZG1qZ3",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___ZG1qZ3",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___ZG1qZ3",
  "p9": "ChannelOverviewTab.module__sectionWrapper___ZG1qZ3",
  "h3": "ChannelOverviewTab.module__settingsGroup___ZG1qZ3",
  "hB": "ChannelOverviewTab.module__settingsControlRow___ZG1qZ3",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___ZG1qZ3",
  "Y4": "ChannelOverviewTab.module__settingsControlText___ZG1qZ3",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___ZG1qZ3",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___ZG1qZ3",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___ZG1qZ3",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___ZG1qZ3",
};

module.exports = exports;
